import { useTranslation } from "react-i18next";
import { useState } from "react";

import apiClient from "../../lib/common/apiClient";

import DeleteRecordButtonLayout from "../layout/DeleteRecordButtonLayout";
import ConfirmDialog from "../dialogTypes/ConfirmDialog";

function TkDeliveryCancelButton ( props ) {

    const { t } = useTranslation();

    const { id, schema, grid, refresh, makeItemName, onSuccess, onFailure, onPartialFailure, ...others } = props;

    const [open, setOpen] = useState(false);
    const [confirmMsg, setConfirmMsg] = useState();
    const [confirmData, setConfirmData] = useState();

    const onOpen = () => {

        setOpen ( true );

        let data = grid.selectedItems[0];

        setConfirmMsg ( t( "dialog.msg.confirm.cancelDelivery", { deliveryNo: data.shipmentNo } ) );
        setConfirmData(data);

    };

    const onClose = () => {

        setOpen ( false );

    };

    const onDeliveryCancelSuccess = (msg) => {

        if(onSuccess) {

            onSuccess(msg);

        }

        refresh.refresh();
    }


    const onOk = (data) => {
        
        let url = `/api/MomSysShipment/${data.shipmentId}/cancel`;

        let form = new FormData();

        let deleted = {};

        form.append("deleted", JSON.stringify(deleted));
        form.append("json", JSON.stringify(data));

        apiClient.patch(url,  {})
        .then((result) => {
            onDeliveryCancelSuccess ( result.data );
        
        })

        .catch ( ( reason ) => {

            onFailure ( t ( "error.updateFailure", { reason: reason.response ? reason.response.data : JSON.stringify ( reason ) } ) );

        });
    }


    return (

        <>
            <DeleteRecordButtonLayout id={id+"cancel-button"} title = {t("buttonName.cancelDelivery")} onClick={onOpen} {...others} />
            <ConfirmDialog
                id={id+"-cancel-confirm-dialog"}
                title={ schema ? t ( `dialog.title.${schema.name}.cancel` ) : "" }
                msg={confirmMsg}
                data={confirmData}
                open={open}
                onClose={onClose}
                onOk={onOk}
                onCancel={onClose}
            />
        </>

    );

}

export default TkDeliveryCancelButton;

